<template>
  <div class="courselist">
    <img
      src="http://ppt.beegoedu.com/Upload/banner/product-banner.png"
      style="width: 100%;"
    />
    <div class="bg-white-wrapper">
      <div class="container">
        <div class="product-search-letter">
          <div class="search-filter">
            <span>类别：</span>
            <div class="sultan-box">
              <a
                :class="{ selected: type == 1 }"
                @click="handleRouter(1)"
                style="cursor: pointer;"
                >职业资格</a
              ><a
                :class="{ selected: type == 2 }"
                @click="handleRouter(2)"
                style="cursor: pointer;"
                >研究生考试</a
              >
            </div>
          </div>
        </div>
        <div class="product-search-letter" style="" v-if="type == 1">
          <div class="search-filter">
            <span>类型：</span>
            <div class="sultan-box">
              <a
                class=""
                style="cursor: pointer;"
                :class="{ selected: examGraduateStudentCategoryId == '' }"
                @click="handleTabExam('')"
                >All</a
              >
              <a
                v-for="item in kaoyanCategoryList"
                class=""
                style="cursor: pointer;"
                :class="{
                  selected:
                    examGraduateStudentCategoryId ==
                    item.examGraduateStudentCategoryId
                }"
                @click="handleTabExam(item.examGraduateStudentCategoryId)"
                >{{ item.categoryName }}</a
              >
            </div>
          </div>
        </div>
        <div class="product-search-letter" style="" v-if="type == 2">
          <div class="search-filter">
            <span>类型：</span>
            <div class="sultan-box">
              <a
                style="cursor: pointer;"
                :class="{ selected: vocationalExamCategoryId == '' }"
                @click="handleTabVocationalExam('')"
                >All</a
              >
              <a
                v-for="item in vocationalExamCategory"
                class=""
                style="cursor: pointer;"
                :class="{
                  selected:
                    vocationalExamCategoryId == item.vocationalExamCategoryId
                }"
                @click="handleTabVocationalExam(item.vocationalExamCategoryId)"
                >{{ item.categoryName }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="product-total">共查询到{{ total }}门课程</div>
      <ul class="product-list">
        <template v-if="type == 1">
          <li v-for="item in examGraduateStudentList">
            <!----><a
              :href="item.examGraduateStudentUrl"
              target="_blank"
              class="product-item"
              :title="item.examGraduateStudentTitle"
            >
              <div class="product-item-image">
                <img
                  :alt="item.examGraduateStudentTitle"
                  :data-src="item.examGraduateStudentCoverImage"
                  :src="item.examGraduateStudentCoverImage"
                  lazy="loaded"
                />
                <!---->
              </div>
              <h2 class="product-item-title">
                {{ item.examGraduateStudentTitle }}
              </h2>
              <span class="product-item-type">{{
                item.examGraduateStudentSubTitle
              }}</span
              ><span class="product-item-price"
                ><s style="display: none;">¥-1</s
                ><span><i>¥</i>{{ item.examGraduateStudentPrice }}</span></span
              >
            </a>
          </li>
        </template>
        <template v-if="type == 2">
          <li v-for="item in vocationalExamList">
            <!----><a
              :href="item.vocationalExamUrl"
              target="_blank"
              class="product-item"
              :title="item.vocationalExamTitle"
            >
              <div class="product-item-image">
                <img
                  :alt="item.vocationalExamTitle"
                  :data-src="item.vocationalExamCoverImage"
                  :src="item.vocationalExamCoverImage"
                  lazy="loaded"
                />
                <!---->
              </div>
              <h2 class="product-item-title">{{ item.vocationalExamTitle }}</h2>
              <span class="product-item-type">{{
                item.vocationalExamSubTitle
              }}</span
              ><span class="product-item-price"
                ><s style="display: none;">¥-1</s
                ><span><i>¥</i>{{ item.vocationalExamPrice }}</span></span
              >
            </a>
          </li>
        </template>
      </ul>
      <div class="page-wrap">
        <div class="page-content">
          <span class="iPre" @click="handlePrev()">
            上一页
          </span>

          <a
            class=""
            :class="{ curr: item == pageNo }"
            v-for="item in totalPage"
            @click="handlePage(item)"
            >{{ item }}</a
          >

          <span class="iNxt" @click="handleNext()">
            下一页
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      data: "",
      type: this.$route.query.type,
      kaoyanCategoryList: [],
      examGraduateStudentCategoryId: -1,
      examGraduateStudentList: [],
      vocationalExamCategory: [],
      vocationalExamCategoryId: -1,
      vocationalExamList: [],
      pageNo: 1,
      pageSize: 6,
      total: 0,
      totalPage: 0
    };
  },
  methods: {
    handleTabVocationalExam(vocationalExamCategoryId) {
      this.vocationalExamCategoryId = vocationalExamCategoryId;
      this.pageNo = 1;
      this.getvocationalExamList();
    },
    handleRouter(type) {
      this.$router.push({
        path: "/productlist?type=" + type
      });
    },
    handlePrev() {
      if (this.pageNo > 1) {
        this.pageNo--;
      }
      this.getList();
    },
    handleNext() {
      if (this.pageNo < this.totalPage) {
        this.pageNo++;
      }
      this.getList();
    },
    handlePage(page) {
      if (page == this.pageNo) {
        return;
      }
      this.pageNo = page;
      this.getList();
    },
    getList() {
      if (this.type == 1) {
        this.getexamGraduateStudentList();
      }
      if (this.type == 2) {
        this.getvocationalExamList();
      }
    },
    handleTabExam(examGraduateStudentCategoryId) {
      this.examGraduateStudentCategoryId = examGraduateStudentCategoryId;
      this.pageNo = 1;
      this.getexamGraduateStudentList();
    },
    getKaoyanCategory() {
      this.$axios
        .get(this.$common.vocationalExam_examGraduateStudentCategoryList)
        .then(res => {
          //   this.bannerList=res.data.data;
          this.kaoyanCategoryList = res.data.data.list;
        });
    },
    getexamGraduateStudentList() {
      this.$axios
        .get(
          this.$common.examGraduateStudent_examGraduateStudentList +
            "?examGraduateStudentCategoryId=" +
            this.examGraduateStudentCategoryId +
            "&pageSize=" +
            this.pageSize +
            "&pageNo=" +
            this.pageNo
        )
        .then(res => {
          this.examGraduateStudentList = res.data.data.list;
          this.total = res.data.data.total;
          this.totalPage = res.data.data.pages;
        });
    },
    getvocationalExamCategory() {
      this.$axios
        .get(this.$common.vocationalExam_vocationalExamCategoryList)
        .then(res => {
          this.vocationalExamCategory = res.data.data.list;
        });
    },
    getvocationalExamList() {
      this.$axios
        .get(
          this.$common.vocationalExam_vocationalExamList +
            "?vocationalExamCategoryId=" +
            this.vocationalExamCategoryId +
            "&pageSize=" +
            this.pageSize +
            "&pageNo=" +
            this.pageNo
        )
        .then(res => {
          this.vocationalExamList = res.data.data.list;
          this.total = res.data.data.total;
          this.totalPage = res.data.data.pages;
        });
    }
  },
  created() {
    this.examGraduateStudentCategoryId = "";
    this.vocationalExamCategoryId = "";
    if (this.type == 1) {
      this.getKaoyanCategory();
    }
    if (this.type == 2) {
      this.getvocationalExamCategory();
    }
    this.getList();
  },
  watch: {
    $route() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.bg-white,
.bg-white-wrapper {
  background-color: #fff;
}

.bg-white-wrapper {
  padding: 10px 0;
}

.product-search-letter {
  position: relative;
  padding-bottom: 10px;
  overflow: hidden;
}

.product-search-letter .search-filter {
  display: flex;
}

.product-search-letter .search-filter > span {
  display: inline-block;
  text-align: left;
  color: #999;
  margin-top: 10px;
  font-size: 16px;
  line-height: 1;
  padding: 6px 8px;
  font-weight: 700;
  vertical-align: top;
  flex: 1;
}

.product-search-letter .sultan-box {
  flex: 23;
}

.product-search-letter .search-filter a {
  display: inline-block;
  text-align: center;
  color: #999;
  margin-right: 10px;
  margin-top: 10px;
  font-size: 16px;
  line-height: 1;
  padding: 6px 8px;
}

.product-search-letter .search-filter a.selected,
.product-search-letter .search-filter a:hover {
  color: #15a9e7;
}

.product-total {
  text-align: right;
  padding: 20px 10px;
  color: #248cfc;
  font-size: 16px;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px auto;
}

li,
ol,
ul {
  list-style: none;
}

.product-list li {
  padding: 0 10px 20px 10px;

  width: 280px;
  position: relative;
  transition: all 0.2s ease-in-out;
}

.product-list li .product-item {
  display: block;
  position: relative;
  background: #fff;
  box-shadow: 0 0 6px rgb(0 0 0 / 20%);
  padding-bottom: 16px;
}

.product-list li .product-item .product-item-image {
  position: relative;
  width: 280px;
  height: 160px;
  overflow: hidden;
}

.product-list li .product-item .product-item-image img {
  width: 100%;
}

.product-list li .product-item .product-item-title {
  padding: 15px 10px 5px 10px;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.product-list li .product-item .product-item-type {
  color: #8e8e8e;
  font-size: 14px;
  height: 14px;
  display: inline-block;
  padding-left: 10px;
}

.product-list li .product-item .product-item-price {
  float: right;
  font-size: 16px;
  font-weight: 700;
  color: #de4848;
  padding-right: 10px;
}

.product-list li .product-item .product-item-price span,
.product-list li .product-item .product-item-price i {
  color: #de4848;
}

.product-list li .product-item .product-item-price s {
  margin-right: 8px;
  color: #999;
  font-size: 12px;
  color: #de4848;
}

.page-wrap {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 36px;
  position: relative;
}

.page-wrap .page-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 34px;
  line-height: 34px;
  font-size: 0;
  color: #555;
}

.page-wrap .page-content .iPre,
.page-wrap .page-content .iNxt {
  font-size: 14px;
  font-weight: normal;
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #e5e5e5;
}

.page-wrap .page-content .aPre,
.page-wrap .page-content .iPre {
  margin-right: 10px;
  cursor: pointer;
}

.page-wrap .page-content .curr {
  font-size: 14px;
  display: inline-block;
  padding: 0 15px;
  background-color: #555;
  border: 1px solid #555;
  color: #fff;
}

.page-wrap .page-content .aNxt,
.page-wrap .page-content .iNxt {
  margin-left: 10px;
  cursor: pointer;
}

.page-wrap .page-content a {
  font-size: 14px;
  display: inline-block;
  padding: 0 15px;
  border: 1px solid #e5e5e5;
  margin-left: -1px;
  cursor: pointer;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/productlist.vue